import React from 'react';
import { Controller } from 'react-hook-form';
import _ from 'lodash';
import clsx from 'clsx';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form'


export default function GroupSelect({accesses}) {
  const methods = useFormContext()

  return (
    <>
      <span className='u-txt--label'>Groups</span><br />
      <Controller
        name='group_ids'
        control={methods.control}
        render={({ field: { onChange, value } }) => (
          <Select
            name='sp-group-select'
            className={clsx('o-select o-select--optgroup', { 'o-select--error': _.get(methods.formState.errors, 'group_ids') })}
            isMulti
            value={(accesses.data?.groups ?? []).filter(o => (value || []).includes(o.value))}
            onChange={(v) => {
              onChange(v.map(v => v.value));
            }}
            options={accesses.data?.groups ?? []}
          />
        )}
      />
      {methods.formState.errors.group_ids && (<p className='u-txt--error'>{methods.formState.errors.group_ids.message}</p>)}
      <p className='u-txt--label'>If an administrator has access to a group, they automatically have access to ALL of the subgroups and cohorts within that group.</p>
    </>
  )
}

GroupSelect.propTypes = {
  accesses: PropTypes.object.isRequired,
};
